import React from 'react';
import { useHistory } from 'react-router-dom';
import { TRACKING_PAGES } from 'api';
import { usePageTracking } from 'hooks';
import { useApp, useDeposit } from 'providers';
import { AuthPageInfo, DepositSidebar, VerticalChoiceForm } from 'components';
import { ROUTES } from 'routes';
import './Deposit.scss';

export const VerticalChoicePage: React.FC = () => {
  const { user } = useApp();
  usePageTracking(user!.isPro ? TRACKING_PAGES.VERTICAL_CHOICE_PRO : TRACKING_PAGES.VERTICAL_CHOICE_PART);
  const history = useHistory();
  const { vehicle } = useDeposit();

  if (!vehicle.registration && !vehicle.vin) {
    history.replace(ROUTES.registration);
  }

  return (
    <>
      <div className="container-left">
        <VerticalChoiceForm />
      </div>
      <div className="container-right">
        {!user?.isPro && <AuthPageInfo />}
        {user?.isPro && <DepositSidebar />}
      </div>
    </>
  );
};
